import React from 'react';
import { AlertCircle, Lightbulb, AlertTriangle, Info } from 'lucide-react';

export const InsightCard = ({ insight }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high':
        return 'bg-state-error/10 border-state-error text-state-error';
      case 'medium':
        return 'bg-state-warning/10 border-state-warning text-state-warning';
      case 'info':
        return 'bg-accent/10 border-accent text-accent';
      default:
        return 'bg-state-info/10 border-state-info text-state-info';
    }
  };

  const getIcon = (type, severity) => {
    if (type === 'ai_recommendation') return Lightbulb;
    if (severity === 'high') return AlertCircle;
    if (severity === 'medium') return AlertTriangle;
    return Info;
  };

  const Icon = getIcon(insight.type, insight.severity);
  const colorClass = getSeverityColor(insight.severity);

  return (
    <div 
      className={`border-l-4 rounded-md p-4 ${colorClass}`}
      data-testid={`insight-${insight.type}`}
    >
      <div className="flex items-start space-x-3">
        <Icon className="h-5 w-5 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <h4 className="font-semibold text-sm mb-1">{insight.title}</h4>
          <p className="text-sm opacity-90 leading-relaxed">{insight.description}</p>
        </div>
      </div>
    </div>
  );
};